import auth from './auth';
import states from './states';
import filters from './filters';

export default {
  auth,
  states,
  filters,
};
